export const OverviewWidgets = [
    'nps-timeline',
    'sentiment-timeline',
    // Could still be in config, we are replacing it with the timeline on load
    'nps-summary',
    // Could still be in config, we are replacing it with the timeline on load
    'sentiment-summary',
    'themes-concepts',
    'compare-themes-concepts',
    'quadrant',
    'timeline',
    'segments',
    'emergent-concepts',
    'pivot-table',
    'segment-correlation',
    'compare-segments',
    'compare-sentiment-timeline',
    'compare-timeline',
    'compare-nps-timeline',
];
export const DrilldownWidgets = [
    'nps-timeline',
    'sentiment-timeline',
    'context-network',
    'verbatims',
    'timeline',
    'query-details',
    'segments',
    'emergent-concepts',
    'key-phrases',
    'summary',
];
export var DateRangeTypeEnum;
(function (DateRangeTypeEnum) {
    DateRangeTypeEnum["ALL_TIME"] = "All time";
    DateRangeTypeEnum["CUSTOM"] = "Custom";
    DateRangeTypeEnum["LAST_7_DAYS"] = "Last 7 Days";
    DateRangeTypeEnum["LAST_14_DAYS"] = "Last 14 Days";
    DateRangeTypeEnum["LAST_30_DAYS"] = "Last 30 Days";
    DateRangeTypeEnum["LAST_90_DAYS"] = "Last 90 Days";
    DateRangeTypeEnum["LAST_12_MONTHS"] = "Last 12 Months";
    DateRangeTypeEnum["LAST_WEEK"] = "Last Week";
    DateRangeTypeEnum["LAST_MONTH"] = "Last Month";
    DateRangeTypeEnum["LAST_QUARTER"] = "Last Quarter";
    DateRangeTypeEnum["LAST_YEAR"] = "Last Year";
    DateRangeTypeEnum["THIS_WEEK"] = "This Week";
    DateRangeTypeEnum["THIS_MONTH"] = "This Month";
    DateRangeTypeEnum["THIS_YEAR"] = "This Year";
})(DateRangeTypeEnum || (DateRangeTypeEnum = {}));
